import { Grid, Typography } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppLoader from "../../../components/AppLoader";
import DashboardStatus from "../../../components/Dashboard/DashboardStatus";
import StatusCard from "../../../components/Dashboard/StatusCard";
import NavigationDrawer from "../../../components/NavigationDrawer";
import appcolors from "../../../constants/Colors";
import { CURRENCY } from "../../../constants/Variables";
import {
  supplierGetDailyReport,
  supplierGetDashboardData,
  supplierGetMonthlyReport,
} from "../../../services/supplier/dashboardApiFn";
import { handleOpenSnackBar } from "../../../utils";
import MainChart from "./MainChart";
import MonthlyReport from "./MonthlyReport";
import AllRecentSales from "./RecentSale";

let months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function SupplierDashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [monthlyReport, setMonthlyReport] = useState([]);
  const [dailyReport, setDailyReport] = useState([]);
  const [startDate, setStartDate] = useState(moment().subtract(7, "days"));
  const [endDate, setEndDate] = useState(moment());

  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    if (userData) {
      fetchDashboardData();
      fetchMonthlyReport();
      fetchDailyReport(startDate, endDate);
    }
  }, [userData]);

  const fetchDashboardData = async () => {
    try {
      setIsLoading(true);
      const response = await supplierGetDashboardData(userData._id);
      if (response?.data?.status === "success") {
        setDashboardData(response?.data?.data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchMonthlyReport = async () => {
    try {
      setIsLoading(true);
      const response = await supplierGetMonthlyReport(userData._id);
      if (response?.data?.status === "success") {
        let reportData = response?.data?.data;
        const finalReport = reportData.map((val, ind) => {
          return {
            month: months[val._id.month - 1],
            totalOrders: val.totalOrders,
            earning: val.totalEarning,
          };
        });
        setMonthlyReport(finalReport);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchDailyReport = async (startDate, endDate) => {
    let query = {
      startDate,
      endDate,
    };
    try {
      setIsLoading(true);
      const response = await supplierGetDailyReport(userData._id, query);
      if (response?.data?.status === "success") {
        let reportData = response?.data?.data;
        const finalReport = reportData.map((val, ind) => {
          return {
            orders: val.totalOrders,
            earnings: val.totalEarnings,
            date: new Date(val._id).getTime(),
          };
        });
        setDailyReport(finalReport);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterByDate = (startDate, endDate) => {
    fetchDailyReport(startDate, endDate);
  };

  const cardData = [
    {
      primary: "totalProducts",
      secondary: "clientOpenedProduct",
      value: dashboardData?.totalProducts || 0,
    },
    {
      primary: "todaySale",
      secondary: moment(new Date()).format("MM/DD/YYYY"),
      value: dashboardData?.totalOrdersToday || 0,
    },
    {
      primary: "currentMonthEarning",
      secondary: moment(new Date()).format("DD/MM/YYYY"),
      value: `${CURRENCY} ${dashboardData?.totalEarnings || 0}`,
    },
  ];

  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading} />
      {/* <Typography
        variant="h3"
        fontSize={"1.125rem"}
        fontWeight={600}
        color={appcolors.gunmetal}
      >
        {t("welcome")} {t(userData?.businessName)}
      </Typography> */}

      <Grid container mt={2} spacing={2}>
        {cardData?.map((val, _ind) => {
          return <StatusCard item={val} />;
        })}
        <Grid item xs={12}>
          <MainChart
            dailyReport={dailyReport}
            isLoading={isLoading}
            handleFilterDate={handleFilterByDate}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AllRecentSales
            tableData={dashboardData?.recentSale}
            isLoading={isLoading}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <MonthlyReport monthlyReport={monthlyReport} isLoading={isLoading} />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default SupplierDashboard;
